export default "__VITE_ASSET__k70kCON8__"